<template>
  <div>
    <!-- 订单Title -->
    <V-DSOrderDetailTitleData :title-data="titleData[0]"></V-DSOrderDetailTitleData>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="REAL_PRICE" label="采购价"></el-table-column>
          <el-table-column prop="BEFORE_TAX_PRICE" label="不含税采购价"></el-table-column>
          <el-table-column prop="PROJECT_SALE_PRICE" label="销售价"></el-table-column>
          <el-table-column prop="PROJECT_SALE_PRICE_BEFORE_TAX" label="不含税销售价">
            <template slot-scope="scope">
              <span>{{ Number(scope.row.PROJECT_SALE_PRICE_BEFORE_TAX).toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="TAX_RATE" label="税率"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订单数量"></el-table-column>
          <el-table-column prop="NEED_COUNT" label="送货数量"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="实收数量" v-if="this.当前供应链公司ID ==6245"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="实收数量" v-else>
            <template slot-scope="scope">
              <el-input size="small" v-model="scope.row.REAL_COUNT" :placeholder="scope.row.REAL_COUNT"
                @change="setActualNumber(scope.row)" clearable>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="采购验收总金额">
            <template slot-scope="scope">
              {{ setTotalFee(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="PRODUCT_FEE_BEFORE_TAX" label="采购不含税验收总金额"></el-table-column>
          <el-table-column prop="销售总金额" label="销售验收总金额"></el-table-column>
          <el-table-column prop="不含税销售总金额" label="销售不含税验收总金额"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
          <el-table-column label="操作" fixed="right" v-if="this.当前供应链公司ID !=6245">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="editProduct(scope.row)" v-if="userPriceType == 1">
                修改
              </el-button>
              <el-button size="small" type="text" @click="editProductSpecial(scope.row)" v-else>修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row style="margin-top:20px">
      <el-col :xl="{ span: 1, offset: 22 }" :lg="{ span: 1, offset: 22 }" :md="{ span: 2, offset: 21 }"
        style="padding-left:4px">
        <el-button type="primary" size="medium" :disabled="isDisabled" @click="__confirm()" :loading="loading">
          全部确认
        </el-button>
      </el-col>
    </el-row>
    <el-dialog title="提示" :visible.sync="tableVisible" width="50%" center :close-on-click-modal="false">
      <p style="color: red">下列为数量产生变动的产品，请再次确认</p>
      <el-table :data="arrData" stripe border style="width: 100%">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="订单数量"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="REAL_COUNT" label="实收数量"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="close()">取 消</el-button>
        <el-button size="small" type="primary" @click="changSubmit()" :loading="loading1">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改" center :visible.sync="editFormVisible" width="600px" :close-on-click-modal="false">
      <el-radio-group v-model="radio" style="display:block;text-align:center;margin-bottom:30px" @change="priceORfee">
        <el-radio label="1">按总额修改</el-radio>
        <el-radio label="2">按数量修改</el-radio>
      </el-radio-group>
      <el-form size="small" :model="editForm" ref="editForm">
        <!-- <el-form-item label="订购数量：" label-width="120px">
          <el-input v-model="editForm.PRODUCT_COUNT" @change="ProductCount" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item> -->
        <el-form-item label="产品名称：" label-width="120px">
          <span>{{ this.editForm.PRODUCT_NAME }}</span>
        </el-form-item>
        <el-form-item label="单位：" label-width="120px">
          <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
          <span>{{ this.editForm.TYPE_UNIT }}</span>
        </el-form-item>
        <el-form-item label="实收数量：" label-width="120px">
          <el-input v-model="editForm.REAL_COUNT" @change="RealCount" @input="countFee"
            oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="单价：" label-width="120px">
          <el-input v-model="editForm.GYS_PRICE" @change="GysPrice" @input="countFee" :disabled="isdisabledPrice"
            oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="不含税单价：" label-width="120px">
          <el-input v-model="editForm.BEFORE_TAX_PRICE" disabled></el-input>
        </el-form-item>
        <el-form-item label="总金额：" label-width="120px">
          <el-input v-model="editForm.TOTAL_FEE" @change="TotalFee" @input="changePrice" :disabled="isdisabledFee"
            oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="不含税总金额：" label-width="120px">
          <el-input v-model="editForm.PRODUCT_FEE_BEFORE_TAX" disabled></el-input>
        </el-form-item>
        <el-form-item label="备注：" label-width="120px">
          <label slot="label">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</label>
          <el-input v-model="editForm.PRODUCT_COMMENT" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="修改数量类型：" label-width="120px">
          <el-radio-group v-model="editForm.typeRadio">
            <el-radio label="0">修改实收数量</el-radio>
            <el-radio label="1">修改产品数量和实收数量</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取 消</el-button>
        <el-button size="small" @click="editSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改" center :visible.sync="specialEditFormVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="specialEditForm" ref="specialEditForm" size="small" :rules="rules" :label-width="formLabelWidth">
        <el-form-item label="产品名称：">
          <span>{{ this.specialEditForm.PRODUCT_NAME }}</span>
        </el-form-item>
        <el-form-item label="单位：">
          <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
          <span>{{ this.specialEditForm.TYPE_UNIT }}</span>
        </el-form-item>
        <el-form-item label="采购价：" prop="REAL_PRICE">
          <label slot="label">采&nbsp;&nbsp;购&nbsp;&nbsp;价：</label>
          <el-input v-model="specialEditForm.REAL_PRICE" @input="specialEditRealPriceInput"></el-input>
        </el-form-item>
        <el-form-item label="不含税采购价：" prop="BEFORE_TAX_PRICE">
          <el-input v-model="specialEditForm.BEFORE_TAX_PRICE" disabled></el-input>
        </el-form-item>
        <el-form-item label="销售价：" prop="销售价" v-show="fun_dic[101010201]">
          <label slot="label">销&nbsp;&nbsp;售&nbsp;&nbsp;价：</label>
          <el-input v-model="specialEditForm.销售价" @change="修改销售价()"></el-input>
        </el-form-item>
        <el-form-item label="实收数量：" prop="REAL_COUNT">
          <el-input v-model="specialEditForm.REAL_COUNT"></el-input>
        </el-form-item>
        <!-- <el-form-item label="备注：" prop="PRODUCT_COMMENT">
          <el-input v-model="editForm.PRODUCT_COMMENT"></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="specialEditFormVisible = false">取 消</el-button>
        <el-button size="small" @click="submitEdit('specialEditForm')" :loading="loading1">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  newHistoryOrderDetailFun,
  modifyOrderFun,
} from '@/assets/api/shopOrderManage';
import { checkOrder } from '@/assets/api/DSOrder';
import http from '@/assets/common/http';
import util from '@/assets/common/util';
import VDSOrderDetailTitleData from '../DSOrder/DSOrderDetailTitleData';
import validation from '@/assets/common/validation';
import { getActionFun } from '@/assets/api/login';

export default {
  data() {
    return {
      当前供应链公司ID: sessionStorage.getItem('tcId'),
      fromName: ['DSOrderConfirmList'],
      toName: [],
      PAGE_ID: '1010102', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 101010201: 0 },
      loading: false,
      loading1: false,
      tableData: [],
      productArray: [],
      titleData: [
        {
          SUPPLIER_NAME: '',
          SEND_DAY: '',
          ORDER_CODE: '',
          TOTAL_GYS_FEE: '',
        },
      ],
      isDisabled: false,
      tableVisible: false,
      changeProducts: [],
      TOTAL_FEE: 0,
      TC_ID: sessionStorage.getItem('companyId'),
      orderId: sessionStorage.getItem('orderId'),
      OTYPE: 0,
      arrData: [],
      loading2: false,
      fileList: [],
      editFormVisible: false,
      radio: '1',
      editForm: {},
      isdisabledPrice: false,
      isdisabledFee: false,
      specialEditFormVisible: false,
      specialEditForm: {},
      rules: {
        REAL_PRICE: [
          { required: true, message: '请输入单价', trigger: 'blur' },
        ],
        REAL_COUNT: [
          { required: true, message: '请输入实收数量', trigger: 'blur' },
        ],
      },
      formLabelWidth: '150px',
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
      CAN_MODIFY_PRICE: sessionStorage.getItem('CAN_MODIFY_PRICE'),
    };
  },
  components: {
    VDSOrderDetailTitleData,
  },
  beforeRouteLeave(to, from, next) {
    // 离开页面前清除订单ID
    if (!this.toName.includes(to.name)) {
      sessionStorage.removeItem('orderId');
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((that) => {
      // 判断是否通过修改URL进入
      if (!that.fromName.includes(from.name) || !sessionStorage.getItem('orderId')) {
        that.$message.show({ text: '请从待确认订单列表进入订单详情', type: 'warning' });
        that.$router.go(-1);
      } else {
        that.queryBeforeFun();
        that.getOrderDetailList();
      }
    });
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // ------------------------------------拉取数据
    getOrderDetailList() {
      const params = {
        ID: Number(sessionStorage.getItem('orderId')),
      };
      newHistoryOrderDetailFun(params)
        .then((result) => {
          if (result[0].list.length) {
            this.tableData = result[0].list.map((item) => ({
              ...item,
              BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2),
              销售总金额: Number(item.PROJECT_SALE_PRICE * item.PRODUCT_COUNT).toFixed(2),
              不含税销售总金额: Number(item.PROJECT_SALE_PRICE_BEFORE_TAX * item.PRODUCT_COUNT).toFixed(2),
              REAL_COUNT: item.PRODUCT_COUNT,
            }));
          }
          const {
            ORDER_ID,
            SEND_DATE,
            CUSTOMER_NAME,
            PROJECT_NAME,
            DK_NAME,
          } = JSON.parse(sessionStorage.getItem('DSOrderDetailTitle'));
          this.titleData = result[0].title.map((item) => ({
            ...item,
            ORDER_ID,
            ORDER_CODE: item.ORDER_CODE,
            SEND_DATE,
            TOTAL_FEE: item.REAL_TOTAL_GYS_FEE,
            SUPPLIER_NAME: item.SUPPLIER_NAME,
            CUSTOMER_NAME,
            PROJECT_NAME,
            DK_NAME,
          }));
          this.productArray = this.tableData.map((item) => ({
            REAL_COUNT: Number(item.PRODUCT_COUNT),
            PRODUCT_COUNT: Number(item.PRODUCT_COUNT),
            ORDER_DETAIL_ID: item.ID,
          }));
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // ---------------------------设置当前产品的实收数量
    currentActualNumber(row) {
      return row.PRODUCT_COUNT;
    },
    // ----------------------------改变实收数量触发
    setActualNumber(row) {
      row.TOTAL_FEE = Math.round(row.REAL_COUNT * Number(row.REAL_PRICE) * 100) / 100;
      row.销售总金额 = Number(row.PROJECT_SALE_PRICE * row.REAL_COUNT).toFixed(2);
      row.不含税销售总金额 = Number(row.PROJECT_SALE_PRICE_BEFORE_TAX * row.REAL_COUNT).toFixed(2);
    },
    // -----------------------------------设置验收总价
    setTotalFee(row) {
      return row.TOTAL_FEE.toFixed(2);
    },
    // -----------------------------------全部确认
    __confirm() {
      if (this.changeProducts.length !== 0) {
        this.arrData = this.changeProducts.filter((ele, index, self) => self.indexOf(ele) === index);
        this.tableVisible = true;
      } else {
        this.changSubmit();
      }
    },
    // ------------------------------------确认按钮
    changSubmit() {
      this.loading = true;
      const submitArr = this.tableData.map((item, index) => ({
        ORDER_DETAIL_ID: Number(item.ID),
        PRODUCT_CODE: item.PRODUCT_CODE,
        NEW_COUNT: Number(item.REAL_COUNT),
        PRODUCT_FEE: Math.round(item.REAL_COUNT * Number(item.REAL_PRICE) * 100) / 100,
      }));
      const params = {
        ORDER_ID: Number(sessionStorage.getItem('orderId')),
        PRODUCT_ARRAY: submitArr,
      };
      this.loading1 = true;
      checkOrder(params).then((result) => {
        if (result) {
          this.$message.show({ text: '确认成功', type: 'success' });
          this.$router.push({ name: 'DSOrderConfirmList' });
          this.loading = false;
          this.loading1 = false;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading = false;
        this.loading1 = false;
      });
    },
    close() {
      this.tableVisible = false;
    },
    editProduct(row) {
      // 关账限制
      if (this.$util.isOrderClosed(this.titleData[0].SEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法对此订单进行操作', type: 'warning' });
        return false;
      }
      this.editFormVisible = true;
      this.editForm = { ...row };
      // this.queryOrderDetailListData();
    },
    editSubmit() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          if (!validation.价格正数0验证(this.editForm.GYS_PRICE)) {
            this.$message.show({ text: '请输入正确的价格', type: 'warning' });
            return;
          }
          const params = {
            SERVICE_ID: '10003',
            OTYPE: 40,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            PRODUCT_CODE: Number(this.editForm.PRODUCT_CODE),
            ORDER_ID: this.orderId,
            ORDER_DETAIL_ID: this.editForm.ID,
            NEW_COUNT: Number(this.editForm.REAL_COUNT),
            PRICE: this.editForm.GYS_PRICE,
            PRODUCT_FEE: Number(this.editForm.TOTAL_FEE),
            BEFORE_TAX_PRICE: Number(this.editForm.BEFORE_TAX_PRICE),
            TAX_RATE: Number(this.editForm.TAX_RATE),
            // PRODUCT_COUNT: this.editForm.PRODUCT_COUNT,
            // MODIFY_REAL_FLAG: 1,
          };
          if (this.editForm.PRODUCT_COMMENT) {
            params.PRODUCT_COMMENT = this.editForm.PRODUCT_COMMENT;
          }
          if (this.editForm.typeRadio) {
            params.MODIFY_REAL_FLAG = Number(this.editForm.typeRadio);
          }

          // if (!this.editForm.PRODUCT_COUNT || !this.editForm.REAL_COUNT) {
          //   this.$message.show({ text: '请输入订购数量和实收数量', type: 'warning' });
          //   return false;
          // }
          // this.loading = true

          for (const key in params) {
            if ([null, undefined, Infinity, NaN].includes(params[key])) {
              this.$message.show({ text: '请输入正确的数', type: 'warning' });
              return false;
            }
          }

          http.post(params).then((result) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.editFormVisible = false;
            this.getOrderDetailList();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    priceORfee(val) {
      if (Number(this.CAN_MODIFY_PRICE) !== 1) {
        this.isdisabledPrice = true;
        this.isdisabledFee = true;
      } else if (Number(this.radio) === 1) {
        this.isdisabledPrice = true;
        this.isdisabledFee = false;
      } else if (Number(this.radio) === 2) {
        this.isdisabledPrice = false;
        this.isdisabledFee = true;
      }
    },
    RealCount(e) {
      this.editForm.REAL_COUNT = e;
    },
    GysPrice(e) {
      this.editForm.GYS_PRICE = e;
    },
    TotalFee(e) {
      this.editForm.TOTAL_FEE = e;
    },
    countFee() {
      if (Number(this.radio) === 1) {
        this.editForm.GYS_PRICE = (Math.round((this.editForm.TOTAL_FEE / this.editForm.REAL_COUNT) * 100) / 100).toFixed(2);
        this.editForm.NEW_BEFORE_TAX_PRICE = Number(((this.editForm.TOTAL_FEE / (1 + this.editForm.TAX_RATE / 100)) / this.editForm.REAL_COUNT).toFixed(10));
        this.editForm.BEFORE_TAX_PRICE = this.editForm.NEW_BEFORE_TAX_PRICE.toFixed(2);
      } else if (Number(this.radio) === 2) {
        this.editForm.NEW_BEFORE_TAX_PRICE = Number((this.editForm.GYS_PRICE / (1 + this.editForm.TAX_RATE / 100)).toFixed(10));
        this.editForm.BEFORE_TAX_PRICE = this.editForm.NEW_BEFORE_TAX_PRICE.toFixed(2);
        this.editForm.TOTAL_FEE = (Math.round((this.editForm.GYS_PRICE * this.editForm.REAL_COUNT) * 100) / 100).toFixed(2);
        this.editForm.PRODUCT_FEE_BEFORE_TAX = (Math.round((Number(this.editForm.GYS_PRICE * this.editForm.REAL_COUNT) / (1 + this.editForm.TAX_RATE / 100)) * 100) / 100).toFixed(2);
      }
    },
    changePrice() {
      if (Number(this.radio) === 1) {
        this.editForm.GYS_PRICE = (Math.round((this.editForm.TOTAL_FEE / this.editForm.REAL_COUNT) * 100) / 100).toFixed(2);
        this.editForm.PRODUCT_FEE_BEFORE_TAX = (Math.round((Number(this.editForm.TOTAL_FEE) / (1 + this.editForm.TAX_RATE / 100)) * 100) / 100).toFixed(2);
        this.editForm.NEW_BEFORE_TAX_PRICE = Number(((this.editForm.TOTAL_FEE / (1 + this.editForm.TAX_RATE / 100)) / this.editForm.REAL_COUNT).toFixed(10));
        this.editForm.BEFORE_TAX_PRICE = this.editForm.NEW_BEFORE_TAX_PRICE.toFixed(2);
      }
    },
    editProductSpecial(row) {
      // 关账限制
      if (this.$util.isOrderClosed(this.titleData[0].SEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法对此订单进行操作', type: 'warning' });
        return false;
      }
      this.specialEditFormVisible = true;
      this.specialEditForm = { ...row, 销售价: row.PROJECT_SALE_PRICE };
    },
    specialEditRealPriceInput(val) {
      val = val.replace(/[^0-9]*/, '');
      this.specialEditForm.NEW_BEFORE_TAX_PRICE = Number((val / (1 + this.specialEditForm.TAX_RATE / 100)).toFixed(10));
      this.specialEditForm.BEFORE_TAX_PRICE = this.specialEditForm.NEW_BEFORE_TAX_PRICE.toFixed(2);
    },
    submitEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
          if (!reg.test(this.specialEditForm.REAL_COUNT)) {
            this.$message.show({ text: '请输入正数订购数量', type: 'warning' });
            return false;
          }
          if (!util.JudgmentUnit(this.specialEditForm.TYPE_UNIT)) {
            // 如果不是
            const beInter = this.specialEditForm.REAL_COUNT % 1 === 0;
            if (beInter == false) {
              this.$message.show({ text: '单位不是KG的，只能输入整数', type: 'warning' });
              return false;
            }
          }
          if (
            !validation.价格正数验证(this.specialEditForm.REAL_PRICE)
          ) {
            this.$message.show({ text: '请输入单价', type: 'warning' });
            return false;
          }
          const updateParams = {
            ORDER_DETAIL_ID: Number(this.specialEditForm.ID),
            ORDER_ID: sessionStorage.getItem('orderId'),
            PRODUCT_COUNT: Number(this.specialEditForm.REAL_COUNT),
            PRICE: this.specialEditForm.REAL_PRICE,
            PRODUCT_COMMENT: this.specialEditForm.PRODUCT_COMMENT,
            PRICE_MODE: this.userPriceType,
            BEFORE_TAX_PRICE: this.specialEditForm.NEW_BEFORE_TAX_PRICE || this.specialEditForm.BEFORE_TAX_PRICE,
            TAX_RATE: this.specialEditForm.TAX_RATE,
          };
          if (this.specialEditForm.销售价 != this.specialEditForm.PROJECT_SALE_PRICE) {
            if (!validation.价格正数验证(this.specialEditForm.销售价)) {
              this.$message.show({ text: '请输入正确的销售价', type: 'warning' });
              return false;
            }
            updateParams.SALE_DETAIL_ID = this.specialEditForm.SALE_DETAIL_ID;
            updateParams.PROJECT_SALE_PRICE = this.specialEditForm.销售价;
          }
          this.loading1 = true;
          modifyOrderFun(updateParams).then((result) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.loading1 = false;
            this.editPriceFormVisible = false;
            this.specialEditFormVisible = false;
            this.getOrderDetailList();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.loading1 = false;
          });
        } else {
          return false;
        }
      });
    },
    修改销售价(val) {
      if (!validation.价格正数验证(this.specialEditForm.销售价)) {
        this.$message.show({ text: '请输入正确的销售价', type: 'warning' });
      }
    },
  },
};
</script>
<style scoped>
ul {
  list-style: none;
  min-height: 50px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 16px;
}

p {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/DSOrder/DSConfirmDetail.vue